export default __webpack_public_path__ + "static/media/CD-BG-01.b797665e.jpg";